<template>
  <v-card>
    <v-card-title> Policy Review </v-card-title>
    <v-card-text>
      <generic-search
        v-model="advisor"
        label="Policy Review on Behalf of"
        placeholder="Search Advisors"
        persistent-hint
        data-testid="agent-advisor"
        clearable
        :composable="useAdvisorSearch"
        :prepend-inner-icon="mdiAccount"
      />
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <app-button class="text-none" @click="dialog.closeDialog()">
        Cancel
      </app-button>
      <app-button
        :href="policyReviewUrl"
        class="text-none"
        target="_blank"
        data-testid="open-policy-review"
        color="primary"
      >
        Open Policy Review
      </app-button>
    </v-card-actions>
  </v-card>
</template>

<script setup>
import GenericSearch from "@/components/shared/GenericSearch.vue";
import { getPolicyReviewUrl } from "@/api/forms.service";
import { useAdvisorSearch } from "@/components/shared/search/advisor-search";
import { useDialogStore } from "@/stores/dialog";
import { computed, ref } from "vue";
import { useUserStore } from "@/stores/user";
const dialog = useDialogStore();
const user = useUserStore();
const advisor = ref({
  name: user.loginable.name,
  id: user.loginable.id,
  type: user.loginable.type
});

const policyReviewUrl = computed(() => {
  let onBehalfOf = advisor.value;
  if (
    advisor.value.type === user.loginable.type &&
    advisor.value.id === user.loginable.id
  ) {
    onBehalfOf = null;
  }
  return getPolicyReviewUrl(onBehalfOf);
});
</script>
